<div class="h-full min-h-0 flex flex-col">
  <!-- Stats Bar -->
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 px-3 lg:px-4 pt-3 shrink-0">
    <div
      class="bg-white rounded-xl border border-slate-200 shadow-sm p-3.5 flex items-center gap-3"
    >
      <div
        class="w-10 h-10 rounded-xl bg-purple-50 flex items-center justify-center shrink-0 ring-1 ring-purple-100"
      >
        <i class="bi bi-box text-purple-600 text-lg"></i>
      </div>
      <div class="min-w-0">
        <p class="text-xs text-slate-500 font-medium">Recursos</p>
        <p class="text-lg font-bold text-slate-800">{{ recursos().length }}</p>
      </div>
    </div>
    <div
      class="bg-white rounded-xl border border-slate-200 shadow-sm p-3.5 flex items-center gap-3"
    >
      <div
        class="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center shrink-0 ring-1 ring-amber-100"
      >
        <i class="bi bi-hourglass-split text-amber-600 text-lg"></i>
      </div>
      <div class="min-w-0">
        <p class="text-xs text-slate-500 font-medium">Pendientes</p>
        <p class="text-lg font-bold text-slate-800">{{ stats().pendientes }}</p>
      </div>
    </div>
    <div
      class="bg-white rounded-xl border border-slate-200 shadow-sm p-3.5 flex items-center gap-3"
    >
      <div
        class="w-10 h-10 rounded-xl bg-teal-50 flex items-center justify-center shrink-0 ring-1 ring-teal-100"
      >
        <i class="bi bi-check-circle text-teal-600 text-lg"></i>
      </div>
      <div class="min-w-0">
        <p class="text-xs text-slate-500 font-medium">Confirmadas</p>
        <p class="text-lg font-bold text-slate-800">{{ stats().confirmadas }}</p>
      </div>
    </div>
    <div
      class="bg-white rounded-xl border border-slate-200 shadow-sm p-3.5 flex items-center gap-3"
    >
      <div
        class="w-10 h-10 rounded-xl bg-accent-50 flex items-center justify-center shrink-0 ring-1 ring-accent-100"
      >
        <i class="bi bi-calendar-event text-accent-600 text-lg"></i>
      </div>
      <div class="min-w-0">
        <p class="text-xs text-slate-500 font-medium">Hoy</p>
        <p class="text-lg font-bold text-slate-800">{{ stats().hoy }}</p>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="flex-1 min-h-0 mt-3 px-3 lg:px-4">
    <app-tabs
      [tabs]="tabs"
      [(activeTab)]="tabActivo"
      (valueChange)="onTabChange($event)"
      class="h-full flex flex-col"
    >
      <div class="flex gap-2 justify-end mb-2 shrink-0 py-2">
        @if (tabActivo() === 'recursos') {
          <app-button
            label="Nuevo recurso"
            icon="bi bi-plus"
            size="sm"
            (onClick)="modalCrearRecurso.set(true)"
          />
        }
        @if (tabActivo() === 'reservas' || tabActivo() === 'agenda') {
          <app-button
            label="Nueva reserva"
            icon="bi bi-plus"
            size="sm"
            (onClick)="modalCrearReserva.set(true)"
          />
        }
      </div>

      <!-- ═══════ TAB: RECURSOS ═══════ -->
      <app-tab-panel value="recursos" [active]="tabActivo() === 'recursos'">
        @if (loadingRecursos()) {
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
            @for (i of [1, 2, 3, 4, 5, 6]; track i) {
              <app-skeleton height="180px" styleClass="rounded-lg" />
            }
          </div>
        } @else if (recursosFiltrados().length === 0) {
          <div class="flex flex-col items-center justify-center py-16 text-slate-400">
            <i class="bi bi-inbox text-5xl mb-3"></i>
            <p class="text-lg font-medium">No hay recursos creados</p>
            <p class="text-sm mt-1 mb-4">Crea tu primer recurso para comenzar a recibir reservas</p>
            <app-button
              label="Crear primer recurso"
              icon="bi bi-plus"
              (onClick)="modalCrearRecurso.set(true)"
            />
          </div>
        } @else {
          @if (recursos().length > 4) {
            <div class="mb-3">
              <input
                type="text"
                [(ngModel)]="searchRecurso"
                placeholder="Buscar recurso..."
                class="w-full sm:w-64 rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400"
              />
            </div>
          }
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mt-1">
            @for (recurso of recursosFiltrados(); track recurso.id) {
              <div
                class="bg-white border border-slate-200 rounded-xl p-4 hover:shadow-md hover:border-slate-300 transition-all group"
              >
                <div class="flex items-start justify-between mb-3">
                  <div class="flex items-center gap-2">
                    <div
                      class="w-10 h-10 rounded-xl flex items-center justify-center text-lg"
                      [class.bg-purple-50]="recurso.activo"
                      [class.bg-slate-100]="!recurso.activo"
                    >
                      @switch (recurso.nombre.toLowerCase()) {
                        @case (
                          recurso.nombre.toLowerCase().includes('sillón') ||
                          recurso.nombre.toLowerCase().includes('silla')
                            ? recurso.nombre
                            : ''
                        ) {
                          <span>💺</span>
                        }
                        @case (
                          recurso.nombre.toLowerCase().includes('doctor') ||
                          recurso.nombre.toLowerCase().includes('dr') ||
                          recurso.nombre.toLowerCase().includes('médico')
                            ? recurso.nombre
                            : ''
                        ) {
                          <span>🩺</span>
                        }
                        @case (
                          recurso.nombre.toLowerCase().includes('salón') ||
                          recurso.nombre.toLowerCase().includes('sala') ||
                          recurso.nombre.toLowerCase().includes('cumpleaños')
                            ? recurso.nombre
                            : ''
                        ) {
                          <span>🎉</span>
                        }
                        @case (
                          recurso.nombre.toLowerCase().includes('barber') ||
                          recurso.nombre.toLowerCase().includes('peluquer') ||
                          recurso.nombre.toLowerCase().includes('barbero')
                            ? recurso.nombre
                            : ''
                        ) {
                          <span>💈</span>
                        }
                        @default {
                          <i class="bi bi-grid text-violet-600"></i>
                        }
                      }
                    </div>
                    <div class="min-w-0">
                      <h3 class="font-semibold text-slate-800 truncate">{{ recurso.nombre }}</h3>
                      @if (!recurso.activo) {
                        <span
                          class="text-xs bg-slate-100 text-slate-500 px-2 py-0.5 rounded-full font-medium"
                          >Inactivo</span
                        >
                      }
                    </div>
                  </div>
                </div>
                @if (recurso.descripcion) {
                  <p class="text-sm text-slate-500 mb-3 line-clamp-2">
                    {{ recurso.descripcion }}
                  </p>
                }
                <div class="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500 mb-3">
                  <span class="flex items-center gap-1"
                    ><i class="bi bi-clock"></i> {{ recurso.duracion_minutos }} min</span
                  >
                  <span class="flex items-center gap-1"
                    ><i class="bi bi-people"></i> Cap. {{ recurso.capacidad }}</span
                  >
                  <span class="flex items-center gap-1 font-medium text-slate-700"
                    ><i class="bi bi-tag"></i> S/ {{ recurso.precio }}</span
                  >
                </div>
                <div class="flex gap-1.5 pt-2 border-t border-slate-100">
                  <app-button
                    label="Horarios"
                    icon="bi bi-clock"
                    size="sm"
                    variant="secondary"
                    class="text-xs"
                    (onClick)="abrirHorarios(recurso)"
                  />
                  <app-button
                    label="Reservar"
                    icon="bi bi-calendar-plus"
                    size="sm"
                    variant="info"
                    class="text-xs"
                    (onClick)="nuevaReservaRapida(recurso.id)"
                  />
                  <div class="flex-1"></div>
                  <button
                    class="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors"
                    (click)="recursoSeleccionado.set(recurso); modalEditarRecurso.set(true)"
                    title="Editar"
                  >
                    <i class="bi bi-pencil text-sm"></i>
                  </button>
                  <button
                    class="p-1.5 rounded-lg hover:bg-rose-50 text-slate-400 hover:text-rose-500 transition-colors"
                    (click)="solicitarEliminarRecurso(recurso)"
                    title="Eliminar"
                  >
                    <i class="bi bi-trash text-sm"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </app-tab-panel>

      <!-- ═══════ TAB: RESERVAS ═══════ -->
      <app-tab-panel value="reservas" [active]="tabActivo() === 'reservas'">
        <div class="flex flex-wrap items-center gap-2 mb-3">
          <app-select
            [options]="estadoOpciones"
            [(value)]="estadoFiltro"
            (onChange)="cargarReservas()"
            placeholder="Estado"
            styleClass="w-36"
          />
          <app-select
            [options]="recursosOpcionesFiltro"
            [(value)]="recursoFiltro"
            (onChange)="cargarReservas()"
            placeholder="Recurso"
            styleClass="w-44"
          />
          @if (estadoFiltro() || recursoFiltro()) {
            <button
              class="text-xs text-slate-500 hover:text-slate-700 underline"
              (click)="estadoFiltro.set(null); recursoFiltro.set(null); cargarReservas()"
            >
              Limpiar filtros
            </button>
          }
        </div>

        @if (loadingReservas()) {
          <div class="space-y-2">
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <app-skeleton height="56px" styleClass="rounded-lg" />
            }
          </div>
        } @else if (reservas().length === 0) {
          <div class="flex flex-col items-center justify-center py-16 text-slate-400">
            <i class="bi bi-calendar-x text-5xl mb-3"></i>
            <p class="text-lg font-medium">No hay reservas</p>
            <p class="text-sm mt-1">Crea una nueva reserva para comenzar</p>
          </div>
        } @else {
          <!-- Desktop table -->
          <div class="hidden lg:block overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
            <table class="w-full text-sm">
              <thead class="bg-slate-50/80 border-b border-slate-200">
                <tr>
                  <th
                    class="p-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider"
                  >
                    Recurso
                  </th>
                  <th
                    class="p-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider"
                  >
                    Cliente
                  </th>
                  <th
                    class="p-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider"
                  >
                    Fecha
                  </th>
                  <th
                    class="p-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider"
                  >
                    Horario
                  </th>
                  <th
                    class="p-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider"
                  >
                    Estado
                  </th>
                  <th
                    class="p-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wider"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-50">
                @for (r of reservas(); track r.id) {
                  <tr
                    class="hover:bg-slate-50/70 transition-colors cursor-pointer"
                    (click)="verReserva(r)"
                  >
                    <td class="p-3 font-medium">{{ r.recurso_nombre }}</td>
                    <td class="p-3">
                      {{ r.cliente_nombre || r.nombre_cliente_no_registrado || '-' }}
                    </td>
                    <td class="p-3">{{ r.fecha | date: 'dd/MM/yyyy' }}</td>
                    <td class="p-3 font-mono text-sm">{{ r.hora_inicio }} - {{ r.hora_fin }}</td>
                    <td class="p-3">
                      <span
                        class="text-xs px-2 py-1 rounded-full font-medium"
                        [class]="estadoClase[r.estado]"
                      >
                        {{ estadoLabels[r.estado] }}
                      </span>
                    </td>
                    <td class="p-3 text-right" (click)="$event.stopPropagation()">
                      <div class="flex gap-1 justify-end">
                        @if (r.estado === 'PENDIENTE') {
                          <app-button
                            label="Confirmar"
                            size="sm"
                            variant="success"
                            class="text-xs px-2 py-1"
                            (onClick)="cambiarEstadoReserva(r)"
                          />
                        }
                        @if (r.estado === 'CONFIRMADA') {
                          <app-button
                            label="Completar"
                            size="sm"
                            variant="info"
                            class="text-xs px-2 py-1"
                            (onClick)="cambiarEstadoReserva(r)"
                          />
                        }
                        @if (r.estado !== 'CANCELADA' && r.estado !== 'COMPLETADA') {
                          <app-button
                            label="Cancelar"
                            size="sm"
                            variant="danger"
                            class="text-xs px-2 py-1"
                            (onClick)="cancelarReserva(r)"
                          />
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Mobile cards -->
          <div class="lg:hidden space-y-2">
            @for (r of reservas(); track r.id) {
              <div
                class="bg-white border border-slate-200 rounded-xl p-3.5 hover:shadow-sm transition-shadow"
                (click)="verReserva(r)"
              >
                <div class="flex justify-between items-start mb-2">
                  <div>
                    <p class="font-semibold text-sm">{{ r.recurso_nombre }}</p>
                    <p class="text-xs text-slate-500">
                      {{ r.cliente_nombre || r.nombre_cliente_no_registrado || 'Sin nombre' }}
                    </p>
                  </div>
                  <span
                    class="text-xs px-2 py-0.5 rounded-full font-medium"
                    [class]="estadoClase[r.estado]"
                  >
                    {{ estadoLabels[r.estado] }}
                  </span>
                </div>
                <div class="flex items-center gap-3 text-xs text-slate-500 mb-2">
                  <span><i class="bi bi-calendar3 mr-1"></i>{{ r.fecha | date: 'dd/MM' }}</span>
                  <span
                    ><i class="bi bi-clock mr-1"></i>{{ r.hora_inicio }} - {{ r.hora_fin }}</span
                  >
                </div>
                @if (r.estado !== 'CANCELADA' && r.estado !== 'COMPLETADA') {
                  <div
                    class="flex gap-1 pt-2 border-t border-slate-100"
                    (click)="$event.stopPropagation()"
                  >
                    @if (r.estado === 'PENDIENTE') {
                      <app-button
                        label="Confirmar"
                        size="sm"
                        variant="success"
                        class="text-xs w-full"
                        (onClick)="cambiarEstadoReserva(r)"
                      />
                    }
                    @if (r.estado === 'CONFIRMADA') {
                      <app-button
                        label="Completar"
                        size="sm"
                        variant="info"
                        class="text-xs w-full"
                        (onClick)="cambiarEstadoReserva(r)"
                      />
                    }
                    <app-button
                      label="Cancelar"
                      size="sm"
                      variant="danger"
                      class="text-xs w-full"
                      (onClick)="cancelarReserva(r)"
                    />
                  </div>
                }
              </div>
            }
          </div>
        }
      </app-tab-panel>

      <!-- ═══════ TAB: AGENDA ═══════ -->
      <app-tab-panel value="agenda" [active]="tabActivo() === 'agenda'">
        <!-- Top bar: resource selector + views + navigation -->
        <div class="flex flex-wrap items-center justify-between gap-2 mb-3">
          <div class="flex items-center gap-2">
            <app-select
              [options]="recursosOpciones"
              [(value)]="recursoAgenda"
              (onChange)="onSeleccionarRecursoAgenda($event)"
              placeholder="Recurso"
              styleClass="w-48"
            />
            <!-- View toggle -->
            <div
              class="flex items-center bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm"
            >
              <button
                class="px-3 py-1.5 text-xs font-medium transition-colors"
                [class.bg-slate-800]="vistaAgenda() === 'mes'"
                [class.text-white]="vistaAgenda() === 'mes'"
                [class.text-slate-600]="vistaAgenda() !== 'mes'"
                (click)="cambiarVista('mes')"
              >
                <i class="bi bi-calendar-month mr-1 hidden sm:inline"></i>Mes
              </button>
              <button
                class="px-3 py-1.5 text-xs font-medium transition-colors border-x"
                [class.bg-slate-800]="vistaAgenda() === 'semana'"
                [class.text-white]="vistaAgenda() === 'semana'"
                [class.text-slate-600]="vistaAgenda() !== 'semana'"
                (click)="cambiarVista('semana')"
              >
                <i class="bi bi-calendar-week mr-1 hidden sm:inline"></i>Sem
              </button>
              <button
                class="px-3 py-1.5 text-xs font-medium transition-colors"
                [class.bg-slate-800]="vistaAgenda() === 'dia'"
                [class.text-white]="vistaAgenda() === 'dia'"
                [class.text-slate-600]="vistaAgenda() !== 'dia'"
                (click)="cambiarVista('dia')"
              >
                <i class="bi bi-calendar-day mr-1 hidden sm:inline"></i>Día
              </button>
            </div>
          </div>
          <!-- Navigation -->
          <div class="flex items-center gap-1">
            @if (vistaAgenda() === 'mes') {
              <button
                class="p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
                (click)="cambiarMes(-1)"
              >
                <i class="bi bi-chevron-left"></i>
              </button>
              <span class="text-sm font-semibold min-w-36 text-center text-slate-700">{{
                getMesLabel()
              }}</span>
              <button
                class="p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
                (click)="cambiarMes(1)"
              >
                <i class="bi bi-chevron-right"></i>
              </button>
            } @else if (vistaAgenda() === 'semana') {
              <button
                class="p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
                (click)="cambiarSemana(-1)"
              >
                <i class="bi bi-chevron-left"></i>
              </button>
              <span
                class="text-sm font-semibold min-w-28 text-center hidden sm:inline text-slate-700"
                >{{ getSemanaLabel() }}</span
              >
              <button
                class="p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
                (click)="cambiarSemana(1)"
              >
                <i class="bi bi-chevron-right"></i>
              </button>
            } @else {
              <app-datepicker
                [(ngModel)]="fechaAgenda"
                (onSelect)="cargarAgenda()"
                dateFormat="dd/mm/yy"
                selectionMode="single"
                styleClass="sm:w-40"
              />
            }
            <button
              class="ml-1 text-xs font-medium text-accent-600 hover:bg-accent-50 px-2.5 py-1 rounded-lg transition-colors"
              (click)="irHoy()"
            >
              Hoy
            </button>
          </div>
        </div>

        <!-- Month view -->
        <!-- Month view -->
        @if (vistaAgenda() === 'mes') {
          <div class="border border-slate-200 rounded-xl bg-white overflow-hidden shadow-sm">
            <div class="grid grid-cols-7 border-b bg-slate-50">
              @for (dia of ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']; track dia) {
                <div
                  class="p-2 text-center text-xs font-semibold text-slate-500 uppercase border-r last:border-r-0"
                >
                  {{ dia }}
                </div>
              }
            </div>
            @for (semana of getSemanasDelMes(); track $index) {
              <div class="grid grid-cols-7 border-b last:border-b-0">
                @for (dia of semana; track $index) {
                  <div
                    class="border-r last:border-r-0 min-h-[85px] sm:min-h-[100px] p-1 relative"
                    [class.bg-blue-50/30]="isHoy(dia)"
                  >
                    @if (dia) {
                      <span
                        class="text-xs font-medium mb-0.5 block"
                        [class.text-blue-600]="isHoy(dia)"
                        [class.text-slate-600]="!isHoy(dia)"
                        >{{ getDiaNumero(dia) }}</span
                      >
                      @for (r of getReservasDelDia(dia); track r.id; let j = $index) {
                        @if (j < 3) {
                          <div
                            class="text-[11px] rounded px-1 py-0.5 mb-0.5 truncate cursor-pointer leading-tight border-l-2"
                            [style.borderLeftColor]="recursoColor(r.recurso_id)"
                            [style.backgroundColor]="recursoColor(r.recurso_id) + '10'"
                            (click)="verReserva(r)"
                            [title]="
                              getRecursoNombre(r.recurso_id) +
                              ' ' +
                              r.hora_inicio.substring(0, 5) +
                              ' ' +
                              (r.cliente_nombre || r.nombre_cliente_no_registrado || '')
                            "
                          >
                            <span class="font-medium">{{
                              getRecursoNombre(r.recurso_id) | slice: 0 : 10
                            }}</span>
                            <span class="font-mono opacity-70 ml-1">{{
                              r.hora_inicio.substring(0, 5)
                            }}</span>
                          </div>
                        }
                      }
                      @if (getReservasDelDia(dia).length > 3) {
                        <span class="text-[10px] text-slate-400 font-medium"
                          >+{{ getReservasDelDia(dia).length - 3 }} más</span
                        >
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Week view -->
        @else if (vistaAgenda() === 'semana') {
          <div class="border border-slate-200 rounded-xl bg-white overflow-hidden shadow-sm">
            <div class="grid grid-cols-7 border-b bg-slate-50">
              @for (dia of getDiasSemana(); track dia) {
                <div
                  class="p-2 text-center border-r last:border-r-0"
                  [class.bg-blue-50]="isHoy(dia)"
                >
                  <p class="text-[10px] sm:text-xs text-slate-500 uppercase">
                    {{ getDiaLabel(dia) }}
                  </p>
                  <p class="text-base sm:text-lg font-bold" [class.text-blue-600]="isHoy(dia)">
                    {{ getDiaNumero(dia) }}
                  </p>
                </div>
              }
            </div>
            <div class="grid grid-cols-7 min-h-[350px]">
              @for (dia of getDiasSemana(); track dia; let i = $index) {
                <div class="border-r last:border-r-0 p-1" [class.bg-blue-50/20]="isHoy(dia)">
                  @if (recursosAgenda()[i]; as reservasDia) {
                    @for (r of reservasDia; track r.id) {
                      <div
                        class="text-[11px] sm:text-xs rounded p-1 mb-0.5 truncate cursor-pointer border-l-2"
                        [style.borderLeftColor]="recursoColor(r.recurso_id)"
                        [style.backgroundColor]="recursoColor(r.recurso_id) + '10'"
                        (click)="verReserva(r)"
                        [title]="
                          getRecursoNombre(r.recurso_id) +
                          ' ' +
                          r.hora_inicio.substring(0, 5) +
                          ' - ' +
                          (r.cliente_nombre || r.nombre_cliente_no_registrado || '')
                        "
                      >
                        <span class="font-medium">{{
                          getRecursoNombre(r.recurso_id) | slice: 0 : 8
                        }}</span>
                        <span class="font-mono ml-1 opacity-70">{{
                          r.hora_inicio.substring(0, 5)
                        }}</span>
                        <span class="ml-1 opacity-60 hidden sm:inline">{{
                          r.cliente_nombre || r.nombre_cliente_no_registrado || '' | slice: 0 : 6
                        }}</span>
                      </div>
                    } @empty {
                      <div class="h-full min-h-[40px] flex items-center justify-center">
                        <span class="text-[10px] text-slate-300">-</span>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          </div>
        }
        <!-- Day view -->
        @else {
          <div class="space-y-1">
            @if (reservas().length === 0) {
              <div class="flex flex-col items-center justify-center py-16 text-slate-400">
                <div
                  class="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center mb-3"
                >
                  <i class="bi bi-calendar2 text-xl text-slate-300"></i>
                </div>
                <p class="font-medium">Sin reservas</p>
                <p class="text-sm">{{ fechaAgenda() | date: 'dd/MM/yyyy' }}</p>
              </div>
            } @else {
              @for (r of reservas(); track r.id) {
                <div
                  class="bg-white border border-slate-200 rounded-xl p-3.5 flex items-center justify-between hover:shadow-sm cursor-pointer transition-shadow"
                  (click)="verReserva(r)"
                >
                  <div class="flex items-center gap-3 min-w-0">
                    <div class="w-14 text-center shrink-0">
                      <p class="text-lg font-bold font-mono text-slate-800">
                        {{ r.hora_inicio.substring(0, 5) }}
                      </p>
                      <p class="text-[11px] text-slate-400 font-mono">
                        {{ r.hora_fin.substring(0, 5) }}
                      </p>
                    </div>
                    <div
                      class="w-1.5 rounded-full shrink-0 self-stretch"
                      [style.backgroundColor]="recursoColor(r.recurso_id)"
                    ></div>
                    <div class="min-w-0">
                      <p class="text-xs font-semibold" [style.color]="recursoColor(r.recurso_id)">
                        {{ getRecursoNombre(r.recurso_id) }}
                      </p>
                      <p class="font-medium text-sm truncate">
                        {{ r.cliente_nombre || r.nombre_cliente_no_registrado || 'Sin nombre' }}
                      </p>
                      @if (r.notas) {
                        <p class="text-xs text-slate-400 mt-0.5 line-clamp-1">{{ r.notas }}</p>
                      }
                      @if (r.telefono_cliente_no_registrado) {
                        <p class="text-[11px] text-slate-400 mt-0.5">
                          <i class="bi bi-telephone mr-1"></i>{{ r.telefono_cliente_no_registrado }}
                        </p>
                      }
                    </div>
                  </div>
                  <span
                    class="text-[11px] px-2 py-0.5 rounded-full font-medium shrink-0 ml-2"
                    [class]="estadoClase[r.estado]"
                    >{{ estadoLabels[r.estado] }}</span
                  >
                </div>
              }
            }
          </div>
        }
      </app-tab-panel>
    </app-tabs>
  </div>

  <!-- ═══════ MODALS ═══════ -->

  <app-dialog
    header="Nuevo recurso"
    [modal]="true"
    [(visible)]="modalCrearRecurso"
    size="md"
    class="w-full max-w-md mx-2"
    (onHide)="modalCrearRecurso.set(false)"
  >
    @if (modalCrearRecurso()) {
      <app-crear-recurso (cerrar)="onCrearRecurso($event)" />
    }
  </app-dialog>

  <app-dialog
    header="Editar recurso"
    [modal]="true"
    [(visible)]="modalEditarRecurso"
    size="md"
    class="w-full max-w-md mx-2"
    (onHide)="modalEditarRecurso.set(false)"
  >
    @if (modalEditarRecurso() && recursoSeleccionado()) {
      <app-editar-recurso [recurso]="recursoSeleccionado()!" (cerrar)="onEditarRecurso($event)" />
    }
  </app-dialog>

  <app-dialog
    header="Horarios de {{ recursoSeleccionado()?.nombre }}"
    [modal]="true"
    [(visible)]="modalHorarios"
    size="lg"
    class="w-full max-w-lg mx-2"
    (onHide)="modalHorarios.set(false)"
  >
    @if (modalHorarios() && recursoSeleccionado()) {
      <app-config-horarios [recurso]="recursoSeleccionado()!" (cerrar)="modalHorarios.set(false)" />
    }
  </app-dialog>

  <app-dialog
    header="Nueva reserva"
    [modal]="true"
    [(visible)]="modalCrearReserva"
    size="lg"
    class="w-full max-w-lg mx-2"
    (onHide)="modalCrearReserva.set(false)"
  >
    @if (modalCrearReserva()) {
      <app-crear-reserva (cerrar)="onCrearReserva($event)" />
    }
  </app-dialog>

  <app-dialog
    header="Detalle de reserva"
    [modal]="true"
    [(visible)]="modalVerReserva"
    size="lg"
    class="w-full max-w-md mx-2"
    (onHide)="modalVerReserva.set(false)"
  >
    @if (modalVerReserva() && reservaViendo(); as r) {
      <div class="flex flex-col gap-3">
        <div class="flex items-center gap-3 pb-3 border-b">
          <span
            class="text-xs px-2 py-1 rounded-full font-medium"
            [class]="estadoClase[r.estado]"
            >{{ estadoLabels[r.estado] }}</span
          >
          <span class="text-sm text-slate-500">{{ r.fecha | date: 'dd/MM/yyyy' }}</span>
        </div>
        <div class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
          <p class="text-slate-500">Recurso</p>
          <p class="font-medium">{{ r.recurso_nombre }}</p>
          <p class="text-slate-500">Horario</p>
          <p class="font-mono">{{ r.hora_inicio }} - {{ r.hora_fin }}</p>
          <p class="text-slate-500">Cliente</p>
          <p>{{ r.cliente_nombre || r.nombre_cliente_no_registrado || '-' }}</p>
          @if (r.telefono_cliente_no_registrado) {
            <p class="text-slate-500">Teléfono</p>
            <p>{{ r.telefono_cliente_no_registrado }}</p>
          }
          @if (r.email_cliente_no_registrado) {
            <p class="text-slate-500">Email</p>
            <p class="truncate">{{ r.email_cliente_no_registrado }}</p>
          }
          @if (r.notas) {
            <p class="text-slate-500">Notas</p>
            <p>{{ r.notas }}</p>
          }
        </div>
        @if (r.estado !== 'CANCELADA' && r.estado !== 'COMPLETADA') {
          <div class="flex gap-2 pt-3 border-t">
            @if (r.estado === 'PENDIENTE') {
              <app-button
                label="Confirmar"
                variant="success"
                class="w-full"
                (onClick)="cambiarEstadoReserva(r); modalVerReserva.set(false)"
              />
            }
            @if (r.estado === 'CONFIRMADA') {
              <app-button
                label="Marcar completada"
                variant="info"
                class="w-full"
                (onClick)="cambiarEstadoReserva(r); modalVerReserva.set(false)"
              />
            }
            <app-button
              label="Cancelar reserva"
              variant="danger"
              class="w-full"
              (onClick)="cancelarReserva(r); modalVerReserva.set(false)"
            />
          </div>
        }
      </div>
    }
  </app-dialog>

  <app-dialog
    header="Eliminar recurso"
    [modal]="true"
    [(visible)]="modalEliminarRecurso"
    size="sm"
    class="w-full max-w-sm mx-2"
    (onHide)="modalEliminarRecurso.set(false)"
  >
    <app-modal-confirmacion
      [mensaje]="
        '¿Eliminar el recurso «' +
        (recursoSeleccionado()?.nombre ?? '') +
        '»? Esta acción no se puede deshacer.'
      "
      textoCancel="Cancelar"
      textoConfirm="Sí, eliminar"
      (confirmar)="confirmarEliminarRecurso()"
      (cancelar)="modalEliminarRecurso.set(false)"
    />
  </app-dialog>
</div>
